import { useEffect } from 'react';

import { SignupResponse } from '@front/pro/src/types/pro';
import { SignupFormContextValue } from '@front/pro/src/signup/types';
import {
  useSubscribedPro,
  useUserInformation,
  useWorkingInformation,
} from '@front/pro/src/signup/signup-form-context';

import { getRoute } from '../routes/routes';

import { useNavigateHistoryWithQuery } from './use-navigate-history-with-query';
import { useWebStepper } from './use-web-stepper';

type UseRedirectToStepParams = Pick<
  SignupFormContextValue,
  'userInformation' | 'workingInformation' | 'additionalInformation'
> & {
  subscribedPro?: SignupResponse;
};
const useStepCheck = ({ userInformation, workingInformation, subscribedPro }: UseRedirectToStepParams) => {
  const { currentStep } = useWebStepper();

  if (!subscribedPro && currentStep === 'confirmation') {
    return getRoute('revenue_simulator');
  }

  if (!userInformation && ['additional_information', 'pro_status'].includes(currentStep)) {
    return getRoute('revenue_simulator');
  }
  if (!workingInformation && currentStep === 'additional_information') {
    return getRoute('pro_status');
  }

  return undefined;
};

// Redirect user to the correct step if it was on a forbiden one
export const useRedirectionStep = () => {
  const { userInformation } = useUserInformation();
  const { workingInformation } = useWorkingInformation();
  const { subscribedPro } = useSubscribedPro();
  const stepToRedirectTo = useStepCheck({ userInformation, workingInformation, subscribedPro });

  const { historyReplaceWithQuery } = useNavigateHistoryWithQuery();

  useEffect(() => {
    if (stepToRedirectTo) historyReplaceWithQuery(stepToRedirectTo);
  }, [historyReplaceWithQuery, stepToRedirectTo]);
};
